export interface ChatbotPageContext {
  readonly pathname: string;
  readonly moduleId: string | null;
  readonly moduleLabel: string;
  readonly matches: ReadonlyArray<string>;
}

interface ChatbotWidgetProps {
  readonly tenantId: string;
  readonly pageContext: ChatbotPageContext;
  /** Override de l'URL de l'API chatbot. Par défaut : VITE_CHATBOT_API_BASE. */
  readonly apiBase?: string;
}

/**
 * Wrapper React autour de @herbo/chatbot-sdk.
 * Charge le SDK en dynamique pour éviter de planter le shell si le package n'est pas
 * encore présent dans le workspace (autre agent en cours de livraison).
 *
 * Le widget reçoit `pageContext` qui est auto-injecté depuis la route active dans App.tsx.
 */
/**
 * ⚠️ ÉTAT RÉEL AU 31/07/2026 — ce widget n'a JAMAIS été branché.
 *
 * Il appelait `mod.mount({ target, tenantId, apiBase, pageContext, accent })`,
 * une signature qui n'existe pas : `@herbo/chatbot-sdk` expose
 * `mountChatbot(config, container)`. L'erreur `mod.mount is not a function`
 * partait donc en `console.error` sur **100 % des pages** — relevé par la passe
 * UX du 31/07 sur les 15 scénarios testés, sans exception.
 *
 * Pourquoi personne ne l'a vu à la compilation : `src/types/external.d.ts`
 * redéclarait le module à la main avec cette API inventée, masquant les vrais
 * types du paquet. La déclaration a été retirée (voir le commentaire là-bas).
 *
 * POURQUOI JE NE LE BRANCHE PAS MAINTENANT (décision de Ben, pas la mienne) :
 * `mountChatbot` exige une configuration de marque complète (`branding`) ET un
 * `chatbot-server` qui tourne sur son propre port. Le brancher ferait
 * apparaître un assistant conversationnel sur les écrans de Virginie, à trois
 * jours de la mise en production — un changement d'interface que personne n'a
 * demandé, et qui échouerait à chaque message si le serveur n'est pas lancé.
 *
 * En attendant l'arbitrage : le composant ne rend rien et n'émet plus d'erreur.
 * Pour le brancher, il faudra appeler `mountChatbot({ tenantId, apiBase,
 * branding, ... }, target)` et utiliser l'instance rendue (`destroy()`,
 * `updateContext()` — cette dernière ne prend AUCUN argument, contrairement à
 * ce que supposait le code d'origine).
 */
export function ChatbotWidget(_props: ChatbotWidgetProps): JSX.Element | null {
  return null;
}
